export class NTdevUtils {

    /**
     * Método para incrustar códigos SVG desde una imagen
     */
    imgToSVG(element = '.imgSVG') {
        jQuery(element).each(function(){
            let $img = jQuery(this);
            let imgID = $img.attr('id');
            let imgClass = $img.attr('class');
            let imgURL = $img.attr('src');
            jQuery.get(imgURL, function(data) {
                let $svg = jQuery(data).find('svg');
                if(typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                if(typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass+' replaced-svg');
                }
                $svg = $svg.removeAttr('xmlns:a');
                if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                    $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
                }
                $img.replaceWith($svg);
            }, 'xml');
        });
    }


    /**
     * Obtener una variable CSS mediante JS
     */
    getVarCSS(varCSS) {
        return getComputedStyle(document.documentElement).getPropertyValue(varCSS);
    }


    /**
     * Editar el valor de una variable CSS mediante JS
     */
    setVarCSS(varCSS, value) {
        document.documentElement.style.setProperty(varCSS, value);
    }


    /**
     * Botón de menu responsive
     */
    buttonMenuResponsive(buttonID, menuID, activeClass){
        const buttonMenu = document.getElementById(buttonID);
        const menu = document.getElementById(menuID);
        const body = document.querySelector('body');
        if (buttonMenu && menu) {
            buttonMenu.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                if (buttonMenu.classList.contains(activeClass)) {
                    buttonMenu.classList.remove(activeClass);
                    menu.classList.remove(activeClass);
                } else {
                    buttonMenu.classList.add(activeClass);
                    menu.classList.add(activeClass);
                }
            });

            menu.addEventListener('click', e => e.stopPropagation() );

            body.addEventListener('click', () => {
                if (menu.classList.contains(activeClass)) {
                    buttonMenu.classList.remove(activeClass);
                    menu.classList.remove(activeClass);
                }
            });
        }
    }


    /**
     * Botón para enviar a alguna sección de la web haciendo scroll
     */
    scrollTo(selector = '.scrolling', time = 1000, offset = 0) {
        document.querySelectorAll(selector).forEach( button => {
            button.addEventListener('click', event => {
                event.preventDefault();
                let to = button.getAttribute('href');
                jQuery('html, body').stop().animate({
                    scrollTop: jQuery(to).offset().top + offset
                }, time);
            });
        });
    }


    /**
     * Método para abrir y cerrar cajas modales mediante el ID
     */
    modalInit(){
        // modal
        const modal = document.querySelectorAll('.modal');
        const modalOpen = document.querySelectorAll('.modalOpen');
        if (modal.length > 0 && modalOpen.length > 0) {
            // botones que abren modal
            modalOpen.forEach(mdOpen => {
                mdOpen.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    let modalID = mdOpen.getAttribute('data-modal-open');
                    let modalToOpen = document.getElementById(modalID);
                    modalToOpen.style.display = 'flex';
                    setTimeout(() => {
                        document.querySelector('html').style.overflowY = 'hidden';
                        modalToOpen.style.opacity = '1';
                    }, 1);
                });
            });
            modal.forEach(md => {
                // evitar propagacion del click dentro del modal
                md.querySelector('.modalContent').addEventListener('click', event => event.stopPropagation() );
                // funcion cerrar modal
                const closeModal = (modalToclose) => {
                    modalToclose.style.opacity = '0';
                    setTimeout(() => {
                        modalToclose.style.display = 'none';
                        document.querySelector('html').style.overflowY = 'auto';
                    }, 300);
                }
                md.querySelector('.modalClose').addEventListener('click', event => {
                    event.preventDefault();
                    closeModal(md);
                });
                md.addEventListener('click', event => {
                    event.preventDefault();
                    closeModal(md);
                });
            });
        }
    }


    /**
     * Método para inicializar el plugin JS de WOW. Requiere jQuery.
     */
    wowInit() {
        //wow
        const wow = new WOW({
            boxClass:     'wow',      // default
            animateClass: 'animated', // default
            offset:       150,          // default
            mobile:       true,       // default
            live:         true        // default
        });
        wow.init();
    }
}